import React, { useState, useEffect } from 'react';
import { PixelAvatar } from '../../utils/avatarGenerator';
import './Lobby.css';

// Mock data for demonstration
const mockPlayers = Array.from({ length: 30 }, (_, i) => ({
  address: `player${i}@wallet`,
  x: Math.floor(Math.random() * 20),
  y: Math.floor(Math.random() * 20),
  status: i < 25 ? 'alive' : 'dead',
}));

export default function Lobby({ walletAddress, hasEntry, onEntry, onTax }) {
  const [players, setPlayers] = useState([]);
  const [activeCount, setActiveCount] = useState(25);
  const [liveCount, setLiveCount] = useState(28);
  const [deadCount, setDeadCount] = useState(2);

  useEffect(() => {
    // Replace with API call in the future
    setPlayers(mockPlayers);
    setActiveCount(mockPlayers.filter(p => p.status === 'alive').length);
    setLiveCount(mockPlayers.length);
    setDeadCount(mockPlayers.filter(p => p.status === 'dead').length);
  }, []);

  // Map size
  const gridSize = 20;

  return (
    <div className="lobby-container">
      {/* Stats Overlay */}
      <div className="stats-overlay">
        <div>Active: {activeCount}</div>
        <div>Live: {liveCount}</div>
        <div>Dead: {deadCount}</div>
      </div>

      {/* Entry/Tax Payment */}
      <div className="entry-section">
        {!hasEntry ? (
          <button className="entry-btn" onClick={onEntry}>Buy Entry</button>
        ) : (
          <button className="tax-btn" onClick={onTax}>Pay Daily Tax</button>
        )}
      </div>

      {/* Map Grid */}
      <div className="map-grid">
        {[...Array(gridSize)].map((_, y) => (
          <div className="map-row" key={y}>
            {[...Array(gridSize)].map((_, x) => {
              const player = players.find(p => p.x === x && p.y === y && p.status !== 'dead');
              return (
                <div className="map-cell" key={x}>
                  {player && <PixelAvatar address={player.address} size={24} />}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
} 